import { makeStyles } from '@rbx/ui';
import styles from '@modules/ui/shared/utils/styles';
import {
  getAppMainTop,
  minSpecBannerHeight,
} from '@modules/layout/layout/constants/layoutConstants';

const useEngineReferenceRightNavContentStyles = makeStyles<{
  showSecondaryNavigation: boolean;
  enableNewLayout: boolean;
}>()((theme, { showSecondaryNavigation, enableNewLayout }) => ({
  container: {
    position: 'sticky',
    top: minSpecBannerHeight,
    paddingLeft: '40px',
    [theme.breakpoints.down('Large')]: {
      paddingLeft: '24px',
    },
  },

  emptyNode: {
    '& > div:first-child > div:first-child': {
      display: 'none',
    },
    '& > div:first-child > div:nth-child(2)': {
      display: 'none',
    },
  },

  listContainer: {
    ...styles.wordBreakWrap,
    width: 'calc(100% + 40px) !important',
    marginLeft: -40,
    overflowY: 'auto',
    maxHeight: `calc(100vh - ${getAppMainTop(showSecondaryNavigation)}px)`,
    paddingLeft: '16px',
    paddingRight: '16px',
    flex: 1,
    minHeight: 0, // Allows flex child to shrink below content size
  },

  drawerListContainer: {
    width: '100%',
    marginLeft: 0,
    padding: '8px 16px 32px',
  },

  listItem: {
    fontSize: '14px',
    lineHeight: '150%',
    color: theme.palette.content.muted,
    margin: '4px',
    borderRadius: theme.shape.borderRadius,
    '&:hover': {
      backgroundColor: theme.palette.states.hover,
    },
  },

  listItemIndented: {
    paddingLeft: '16px',
  },

  listItemActive: {
    backgroundColor: theme.palette.states.hover,
    color: theme.palette.content.standard,
  },

  listItemSection: {
    marginTop: '8px',
    marginBottom: '8px',
  },

  listItemDeprecated: {
    color: theme.palette.content.disabled,
  },

  listLink: {
    fontSize: 14,
    fontWeight: 'inherit',
    borderRadius: theme.shape.borderRadius,
    display: 'block',
    textDecoration: 'none',
    padding: enableNewLayout ? '4px 8px' : '4px',
    lineHeight: '150%',
    '&:hover, &:focus, &:active': {
      backgroundColor: 'transparent',
    },
    ...styles.textClamp(1),
  },

  listLinkContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },

  listIcon: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
  },

  drawerContent: {
    backgroundColor: theme.palette.surface[0],
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },

  navReferenceName: {
    fontSize: 16,
    fontWeight: 700,
    color: theme.palette.content.standard,
  },

  referenceNameWithClose: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  drawerCloseButton: {
    padding: '4px',
    marginRight: '-8px',
  },

  referenceActionButtons: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '8px',
    marginTop: '16px',
    borderTop: `1px solid ${theme.palette.components.divider}`,
    '& [class*="Typography-body1"]': {
      fontSize: '14px',
    },
  },
}));

export default useEngineReferenceRightNavContentStyles;
